import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./i18n";
import { initPostHog } from "./lib/posthog";
import { ErrorBoundary } from "@/components/error-boundary";

// Initialize PostHog
initPostHog();

// VP-255: nieudany import lazy chunka (deploy podmienił assety w trakcie sesji,
// stary index.html w cache przeglądarki) kończył się białym ekranem. Twardy
// reload pobiera świeży index.html (no-cache) ze spójnym zestawem chunków.
// Guard w sessionStorage zapobiega pętli reloadów, gdy chunk faktycznie nie istnieje.
window.addEventListener("vite:preloadError", (event) => {
  const RELOAD_GUARD_KEY = "vite_preload_error_reloaded";
  if (sessionStorage.getItem(RELOAD_GUARD_KEY) === window.location.href) return;
  sessionStorage.setItem(RELOAD_GUARD_KEY, window.location.href);
  event.preventDefault();
  window.location.reload();
});

// react-grab: kopiowanie elementów UI z kontekstem źródłowym dla agentów AI.
// Tylko dev + jawny opt-in przez REACT_GRAB=true w .env; w buildzie produkcyjnym
// gałąź jest usuwana (DEV=false), więc pakiet nie trafia do bundla.
if (import.meta.env.DEV && __REACT_GRAB__) {
  import("react-grab");
}

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
